<template>
    <div class="of-container flex space-evenly row vertical-center">
        <div class="flex row md-container">
            <div class="flex column hex-container">
                <div class="relative pc-hex">
                    <img :src="require('../../assets/Desktop/Home_Landing/PC_Hex.png')" alt="Private Customer">
                    <h3 class="absolute absolute-center hex-text">PRIVATE CUSTOMER</h3>
                </div>
                <div class="relative bc-hex">
                    <img :src="require('../../assets/Desktop/Home_Landing/BC_Hex.png')" alt="Business Customer">
                    <h3 class="absolute absolute-center hex-text" style="left: 43%;">BUSINESS CUSTOMER</h3>
                </div>
                <div class="relative v-hex">
                    <img :src="require('../../assets/Desktop/Home_Landing/V_Hex.png')" alt="Vendor">
                    <h3 class="absolute absolute-center hex-text">VENDOR</h3>
                </div>
            </div>
        </div>
        <div class="flex row mobile-hex">
            <div class="flex row">
                <div class="relative pc-hex">
                    <img :src="require('../../assets/Mobile/Mobile_Landing/Hex_1.png')" alt="Private Customer">
                    <h3 class="absolute absolute-center hex-text">PRIVATE CUSTOMER</h3>
                </div>
                <div class="relative bc-hex">
                    <img :src="require('../../assets/Mobile/Mobile_Landing/Hex_3.png')" alt="Business Customer">
                    <h3 class="absolute absolute-center hex-text" style="left: 43%;">BUSINESS CUSTOMER</h3>
                </div>
                <div class="relative v-hex">
                    <img :src="require('../../assets/Mobile/Mobile_Landing/Hex_2.png')" alt="Vendor">
                    <h3 class="absolute absolute-center hex-text">VENDOR</h3>
                </div>
            </div>
        </div>
        <div class="flex vertical-center center">
            <img :src="require('../../assets/Desktop/Home_Landing/02-img.svg')" alt="Page 2">
        </div>
        <div class="mg-spacing">
            <h1 class="re-title md-container" style="white-space:pre; text-align:right; width:fit-content;">{{title}}</h1>
            <h1 class="re-title mobile-title" style="white-space:pre; text-align:right; width:fit-content;">What We Offer</h1>
        </div>
        <div class="mg-spacing">
            <h3 class="of-subtitle re-text">Business Customer</h3>
            <p class="re-text">Money savings - Your events staff doesn’t have to be huge or hiring a 3rd party company doesn’t have to happen because the app handles all the legwork and phone calls for your company meetings, team building trips, and anything else.</p>
            <p class="re-text">Efficiency - Using the app will allow your staff the time to concentrate on other productive activities and do a better job at them</p>
        </div>
        <re-panel-nav style="width:215px;" class="lg-container"
            v-on:app="sendMessage('re-the-applciation')"
            v-on:offer="sendMessage('re-the-offering')"
            v-on:company="sendMessage('re-company-breakdown')"
        >
        </re-panel-nav>
    </div>
</template>

<script>
    import Panel_Nav from './Panel_Nav.vue'

    export default {
        data () {
            return {
                title: "What\nWe\nOffer"
            }
        },
        mounted: function() {
            let nav_location = document.querySelectorAll('.of-container')[0].querySelectorAll('.to-item')[0]
            nav_location.style['font-size'] = '15px';
            nav_location.style['color'] = '#DAAE3E';
        },
        components: {
            're-panel-nav': Panel_Nav
        },
        methods: {
            sendMessage(message){
                this.$emit('scroll_location', message)
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .of-container {
            width: 100vw !important;
            height: 1000px !important;
            background-image: url(../../assets/Mobile/Mobile_Landing/offer_mobile.jpg) !important;
            flex-direction: column !important;
            background-position: center !important; /* Center the image */
            background-repeat: no-repeat !important; /* Do not repeat the image */
            background-size: 100% 100% !important;
        }

        .mobile-title {
            display: block !important;
            font-size: 29px !important;
        }

        .mobile-hex {
            display: flex !important;
        }

        .hex-text {
            font-size: 14px !important;
            letter-spacing: 2.42px !important;
            line-height: 18px !important;
            left: 50% !important;
        }

        .bc-hex {
            top: -67% !important;
        }

        .pc-hex {
            top: 13% !important;
            left: 15% !important;
        }

        .v-hex {
            top: 13% !important;
            bottom: auto !important;
            left: auto !important;
            right: 15% !important;
        }

        .absolute-center {
            top: 40% !important;
        }

        .mg-spacing {
            margin: 0 !important;
        }
    }

    .mobile-hex {
        display:none;
    }

    .mobile-title {
        display: none;
    }

    .of-container {
        height: 722px;
        background-image: url(../../assets/Desktop/Home_Landing/offering_img.jpg);
    }

    .absolute-center {
        top: 46%;
        left: 49%;
        transform: translate(-50%, -50%);
    }

    .of-subtitle {
        font-size: 18px;
    }

    .re-text {
        width: 325px;
        text-align: left;
        margin: 25px auto;
    }

    .mg-spacing {
        margin: 25px;
    }

    .pc-hex {
        top: 9%;
        left: 45%;
    }

    .v-hex {
        bottom: 9%;
        left: 45%;
    }

    .hex-text {
        color: #FFFFFF;
        width: fit-content;
        font-family: Oswald;
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 4.15px;
        line-height: 61px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/The_Offering.vue